import { Box } from "@chakra-ui/react";

const CheckoutContent: React.FC = ({ children }) => {
    return <Box fontSize="30px" marginTop="auto" textAlign="center">
        {children}
    </Box>;
}

export default CheckoutContent;